
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCustomAddressList } from '@/api/company';

@Component({
  name: 'orderAddressCustom'
})
export default class extends Vue {
  // 接受父组件的值

  @Prop({
    type: String,
    default: ''
  })companyId!:String;

  @Prop({
    type: Boolean,
    default: false
  })addressCustomVisible!:Boolean;

  @Prop({
    type: Boolean,
    default: false
  })isMultilevelRadio?:Boolean;

  created() {
    this.getCustomAddressList('0', 1, '0');
  }
  private expands:any=[]
  private expands1:any=[]

  private getCustomAddressList(pLevBean:any, lev:number, ppid:string) {
    let pid = pLevBean.id;
    var parameters:any = {};
    parameters.company_id = this.companyId ? this.companyId : UserModule.getCompanyId;
    parameters.pid = pid;
    getCustomAddressList(parameters).then(res => {
      if (res.data) {
        let list:any = res.data.list;
        switch (lev) {
          case 1:
            this.tableData = list;
            break;
          case 2:
            for (var m = 0; m < this.tableData.length; m++) {
              if (this.tableData[m].id === pid) {
                for (var i = 0; i < list.length; i++) {
                  list[i]['pBean'] = JSON.stringify(pLevBean);
                }
                this.$set(this.tableData[m], 'tableData2', list);
              }
            }

            break;
          case 3:
            for (var p = 0; p < this.tableData.length; p++) {
              if (this.tableData[p].id === ppid) {
                for (var n = 0; n < this.tableData[p].tableData2.length; n++) {
                  if (this.tableData[p].tableData2[n].id === pid) {
                    for (var k = 0; k < list.length; k++) {
                      list[k]['pBean'] = this.tableData[p].tableData2[n].pBean;
                      list[k]['pBean1'] = JSON.stringify(pLevBean);
                    }
                    this.$set(this.tableData[p].tableData2[n], 'tableData3', list);
                  }
                }
              }
            }
            break;
        }
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private radioSelect = ''
  private tableData:any=[]

  private firstExpand(val:any, expand:any, lev:number, ppid:string) {
    let arr = expand.filter((rrr : any) => {
      return val.id === rrr.id;
    });
    if (arr && arr.length > 0) {
      if (lev === 2) {
        this.expands.push(val.id);
      }
      if (lev === 3) {
        this.expands1.push(val.id);
      }

      this.getCustomAddressList(val, lev, ppid);
    } else {
      if (lev === 2) {
        var index = this.expands.indexOf(val.id);
        if (index > -1) {
          this.expands.splice(index, 1);
        }
      }
      if (lev === 3) {
        var index1 = this.expands1.indexOf(val.id);
        if (index1 > -1) {
          this.expands1.splice(index1, 1);
        }
      }
    }
  }
  private close() {
    this.$emit('close', false);
  }
  private save() {
    this.$emit('save', this.radioSelect);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
